module.exports = __webpack_public_path__ + "static/img/Christian-Moraes.5a4c709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Christian-Moraes.jpg
// module id = sutz
// module chunks = 0